<label class="{{ class }}">
  {{ compTitle }}
</label>
